import React from 'react';
import PublicLayout from '@/components/PublicLayout';
import SEO from '@/components/SEO';
import { Mail, MapPin, Clock } from 'lucide-react';

const ContactUsPage = () => (
  <PublicLayout>
    <SEO title="Contact Us" description="Get in touch with the EdAssist team. We're here to help schools, institutions, and educators with their hiring and job search needs." path="/contact" />
    <div data-testid="contact-us-page">
      {/* Hero */}
      <section className="bg-gradient-to-br from-indigo-600 via-indigo-700 to-slate-900 text-white py-16">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h1 className="text-3xl lg:text-5xl font-bold mb-4" style={{ fontFamily: 'Outfit' }}>Get in Touch with EdAssist</h1>
          <p className="text-lg text-indigo-100 max-w-2xl mx-auto">Have questions about our Employer Plans or partnership opportunities? Our dedicated team is here to guide you through hiring solutions, pricing, and collaborations that connect schools with qualified educators across India.</p>
        </div>
      </section>

      <div className="max-w-4xl mx-auto px-4 py-16">
        <div className="grid md:grid-cols-2 gap-10">
          {/* Contact Details */}
          <div className="space-y-8">
            <div>
              <h2 className="text-2xl font-bold text-slate-900 mb-6" style={{ fontFamily: 'Outfit' }}>Contact Information</h2>

              <div className="space-y-5">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 bg-indigo-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <MapPin className="w-5 h-5 text-indigo-600" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-slate-900">Office Address</h3>
                    <p className="text-slate-600 text-sm mt-1">
                      <strong>EdAssist</strong> (HRassistance India Consultancy LLP)<br />
                      205 A, Town Square Shopping Center,<br />
                      New Airport Rd, Viman Nagar,<br />
                      Pune, Maharashtra 411014, India
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Mail className="w-5 h-5 text-green-600" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-slate-900">Email</h3>
                    <a href="mailto:info@edassist.co.in" className="text-indigo-600 hover:underline text-sm mt-1 block">info@edassist.co.in</a>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 bg-amber-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Clock className="w-5 h-5 text-amber-600" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-slate-900">Business Hours</h3>
                    <p className="text-slate-600 text-sm mt-1">
                      Monday – Saturday: 10:00 AM – 7:00 PM IST<br />
                      Sunday: Closed
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Map Embed */}
          <div className="rounded-2xl overflow-hidden border border-slate-200 shadow-sm">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3782.2547296619844!2d73.91411937589658!3d18.56457926820604!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2c147b8b3a3bf%3A0x6f7b1c6b3e2d2c5e!2sTown%20Square%20Shopping%20Center!5e0!3m2!1sen!2sin!4v1700000000000!5m2!1sen!2sin"
              width="100%"
              height="100%"
              style={{ border: 0, minHeight: 350 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="EdAssist Office Location"
            />
          </div>
        </div>
      </div>
    </div>
  </PublicLayout>
);

export default ContactUsPage;
